"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports._decorateChildren = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var React = _interopRequireWildcard(require("react"));

var _ResponsiveGridMarkers = require("./ResponsiveGridMarkers");

var _decorateChildren = function _decorateChildren(children) {
  var _context;

  var lastChildIndex = React.Children.count(children) - 1;
  return (0, _map.default)(_context = React.Children).call(_context, children, function (child, i) {
    if (_ResponsiveGridMarkers.ResponsiveGridCellMarker.isMarked(child) && (i === 0 || i === lastChildIndex)) {
      return /*#__PURE__*/React.cloneElement(child, {
        isFirst: i === 0,
        isLast: i === lastChildIndex
      });
    }

    return child;
  });
};

exports._decorateChildren = _decorateChildren;